import {
  type CollectionReference,
  type DocumentReference,
  type Timestamp,
  asColRef,
  uid,
} from '@principle-theorem/shared';
import {
  type IMigrationUploadCode,
  type IMigrationUploadSession,
  type UploadType,
} from '@principle-theorem/practice-migrations/interfaces';
import { RootCollection } from '@principle-theorem/principle-core/interfaces';

export class MigrationUploadCode {
  static col(): CollectionReference<IMigrationUploadCode> {
    return asColRef<IMigrationUploadCode>(RootCollection.MigrationUploadCodes);
  }

  static init(
    code: string,
    sessionRef: DocumentReference<IMigrationUploadSession>,
    expiresAt: Timestamp,
    downloadToken: string
  ): IMigrationUploadCode {
    return {
      code,
      sessionRef,
      expiresAt,
      deleted: false,
      downloadToken,
    };
  }

  static generate(uploadType: UploadType): string {
    return `${uploadType}-${uid()}`;
  }
}
